import { NumericFormat } from "react-number-format";
import { FormatInputValueFunction, InputAttributes, NumberFormatValues, OnValueChange, RemoveFormattingFunction } from "react-number-format/types/types";
import { ITextFieldProps } from "../TextField";
import { OutlinedInputProps, SxProps, TextField, Theme, styled } from "@mui/material";
import { ChangeEvent, ComponentType, useEffect, useState } from "react";
import { AutoCompleteTargetNumber } from "src/parts/Types/autocomplete.target";
import ModulEnum from "src/enums/ModulEnum";
import { isVisible } from "src/utils/formAuthHelper";
//import PropTypes from "prop-types";

class DefNumberFieldClass {
  disabled?: boolean = true;
  required?: boolean = true;
  thousandSeparator?: boolean = false;
  startAdornment?: React.ReactNode;
}
export interface INumberFieldProps extends DefNumberFieldClass {
  value: number;
  InputProps?: Partial<OutlinedInputProps>;
  onChange?: (e: AutoCompleteTargetNumber, v?: NumberFormatValues) => void;
  defaultValue?: OutlinedInputProps['defaultValue'] // sonradan eklendi
  name?: string;
  label?: string;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
  allowNegative?: boolean;
  allowLeadingZeros?: boolean;
  suffix?: string;
  prefix?: string;
  helperText?: string;
  error?: boolean;
  placeholder?: string;
  maxLength?: number;
  autoFocus?: boolean;
  max?: number;
  sx?: SxProps<Theme>;// sonradan eklendi
  id?: string;// sonradan eklendi
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
  variant?: 'standard' | 'outlined' | 'filled';
  isAllowed?: (values: NumberFormatValues) => boolean;
  format?: FormatInputValueFunction;
  removeFormatting?: RemoveFormattingFunction;
  getInputRef?: ((el: HTMLInputElement) => void) | React.Ref<any>;
  valueIsNumericString?: boolean;
  onValueChange?: OnValueChange;
  onMouseUp?: InputAttributes['onMouseUp'];
  onFocus?: InputAttributes['onFocus'];
  onBlur?: InputAttributes['onBlur'];
  getCaretBoundary?: (formattedValue: string) => boolean[];
  isValidInputCharacter?: (character: string) => boolean;
  step?: number | string;
  borderNone?: boolean;
  authCode?: string;
  modul?: ModulEnum;
};

const CustomFieldNone = styled(TextField)(() => ({
  "& fieldset": { border: "none" },
}));
const CustomFieldAuto = styled(TextField)(() => ({
  width: "100%",
  "& fieldset": { border: "auto" },
}));

const NumberField = (props: INumberFieldProps): JSX.Element => {
  let thousandSeparator = props.thousandSeparator && ".";
  let decimalSeparator = ",";
  switch (localStorage.getItem("lang")) {
    // case "US":
    //   break;
    case "FR":
      thousandSeparator = ",";
      decimalSeparator = ".";
      break;
  }
  const [value, setValue] = useState(null);

  // useEffect(() => {
  //   if (props.value === undefined)
  //     setValue(null)
  //   else if (props.value === 0)
  //     setValue(0)
  //   else if (props.value === null)
  //     setValue("") //Component null ile render yapmadığı için tırnak eklendi.
  //   else setValue(props.value.toString().replace(".", ","))
  // }, [props.value]);

  // `customInput` adında bir ComponentType tanımlanıyor ve bu bileşen, ITextFieldProps türündeki özelliklere sahip bir TextField bileşenine eşitleniyor.
  const customInput: ComponentType<ITextFieldProps> = props?.borderNone ? CustomFieldNone : CustomFieldAuto;

  //#TODO: Prop borderNone geçilmeyen yerlerdede bozulmalar çıkıyor kontrol edilecek. (prop geçilen sayfadan sonra prop olmayan sayfaya geçildiğinde inputu bozuyor).
  // customInput.propTypes = {
  //   borderNone: PropTypes.bool
  // };
  // // `customInput` bileşeninin varsayılan özellikleri belirleniyor.
  // customInput.defaultProps = {
  //   // `borderNone` özelliği, dışarıdan gelen `props` objesinden alınıyor ve `customInput` bileşeninin varsayılan özellikleri arasına ekleniyor.
  //   // Bu sayede, `customInput` bileşeni kullanıldığında, `borderNone` özelliği tanımlanmışsa, varsayılan değeri olarak kullanılacaktır.
  //   borderNone: props.borderNone
  // };

  useEffect(() => {
    let val: number = props?.value >= 0 ? props.value : null;
    if (val >= 0) {
      props.onChange({ target: { name: props.name, value: val } });
      setValue(val);
    }
  }, [props.value]);

  return (
    isVisible(props.authCode, props.modul) && (
      <NumericFormat
        value={value}
        defaultValue={null}
        onValueChange={(e, s) => {
          if (props.onChange) {
            let val = e.floatValue === 0 ? 0 : (!e.floatValue ? null : e.floatValue) || null;
            props.onChange({ target: { name: props.name, value: val } }, e);
            setValue(val);
          }
        }}
        onKeyDown={props.onKeyDown}
        max={props.max}
        isAllowed={props.isAllowed}
        name={props.name}
        label={props.label}
        step={props.step}
        decimalScale={props.decimalScale || 0}
        fixedDecimalScale={props.decimalScale > 0}
        allowNegative={props.allowNegative}
        allowLeadingZeros={props.allowLeadingZeros}
        suffix={props.suffix}
        prefix={props.prefix}
        helperText={props.helperText}
        error={props.error}
        placeholder={props.placeholder}
        required={props.required}
        thousandSeparator={thousandSeparator}
        decimalSeparator={decimalSeparator}
        disabled={props.disabled}
        autoFocus={props.autoFocus}
        allowedDecimalSeparators={[","]}
        InputProps={{
          ...props.InputProps,
          inputProps: {
            style: { textAlign: "right" },
            maxLength: props.maxLength
          },
          startAdornment: props.startAdornment,
          size: "small"
        }}
        sx={props.sx} // sonradan eklendi
        id={props.id} //sonradan eklendi
        customInput={customInput}
        InputLabelProps={{
          shrink: true
        }}
        variant={props.variant ? props.variant : "outlined"}
        getInputRef={props.getInputRef}
        valueIsNumericString={false}
        onMouseUp={props.onMouseUp}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
      />
    )
  )
};
NumberField.defaultProps = {
  onChange: () => { },
};
export default NumberField;
